import { COMPANY } from "@/i18n";
import { useVideoPlayer } from "@/hooks/use-video-player";
import VideoPlayOverlay from "@/components/sections/showcase/VideoPlayOverlay";
import VideoMuteToggle from "@/components/sections/showcase/VideoMuteToggle";

export default function ShowcaseVideoPlayer({ t }) {
  const { videoRef, playing, muted, handlePlay, toggleMute, onEnded } = useVideoPlayer();

  return (
    <div className="relative reveal">
      <div className="absolute -inset-4 bg-gradient-to-br from-[#1995AD]/30 to-[#E05A33]/15 rounded-[2rem] blur-2xl" />
      <div
        className="relative card-surface overflow-hidden p-0 aspect-video bg-black"
        data-testid="showcase-video-wrap"
      >
        <video
          ref={videoRef}
          className="w-full h-full object-contain bg-black"
          playsInline
          preload="metadata"
          controls={playing}
          onEnded={onEnded}
          data-testid="showcase-video"
        >
          <source src={COMPANY.videoUrl} type="video/mp4" />
          <source src={COMPANY.videoUrl} type="video/quicktime" />
          {t.showcase.noSupport}
        </video>

        {!playing && (
          <VideoPlayOverlay
            onPlay={handlePlay}
            playLabel={t.showcase.play}
            durationLabel={t.showcase.duration}
          />
        )}
        {playing && <VideoMuteToggle muted={muted} onToggle={toggleMute} />}
      </div>
    </div>
  );
}
